import { CartProps } from 'types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ICartDataState {
  cartData: CartProps;
}

const initialState: ICartDataState = {
  cartData: null,
};

const cartDataSlice = createSlice({
  name: 'cartData',
  initialState,
  reducers: {
    setCartData: (state, action: PayloadAction<CartProps>) => {
      state.cartData = action.payload;
    },
  },
});

export const { setCartData } = cartDataSlice.actions;
export default cartDataSlice.reducer;
